/**
 * Feature flag BOTTOM_NAV_V1 — navegación inferior
 * (curso académico + CPA; funcionarios / kiosk siguen legacy).
 *
 * Activo por defecto para pruebas locales.
 * Desactivar sin rebuild:
 *   localStorage.setItem('BOTTOM_NAV_V1', '0')
 * Reactivar:
 *   localStorage.setItem('BOTTOM_NAV_V1', '1')
 * o borrar la clave.
 *
 * Env (build): VUE_APP_BOTTOM_NAV_V1=false para forzar apagado en un build.
 */
const STORAGE_KEY = "BOTTOM_NAV_V1";
const localOverride = () => {
    if (typeof window === "undefined")
        return null;
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw === "0" || raw === "false")
        return false;
    if (raw === "1" || raw === "true")
        return true;
    return null;
};
/** Flag global (aún requiere elegibilidad por membresía activa). */
export const isBottomNavV1Enabled = () => {
    const override = localOverride();
    if (override !== null)
        return override;
    if (process.env.VUE_APP_BOTTOM_NAV_V1 === "false")
        return false;
    if (process.env.VUE_APP_BOTTOM_NAV_V1 === "true")
        return true;
    // Default ON para validar en local antes de decidir deploy.
    return true;
};
